//Регистронезависимая, допускается только кирилица, латиница, слова через пробел или тире
const VACANCY_REGEXP = /^[0-9a-zа-яё]+(\s*[\-—]?\s*[a-zа-яё]+)*$|^$/i

//Номер телефона в формате +7 и 10 цифр от 0 до 10
const PHONE_NUMBER_REGEXP = /^(\+7[0-9]{10})$/g

const NAME_REGEXP = VACANCY_REGEXP

export {
  VACANCY_REGEXP,
  PHONE_NUMBER_REGEXP,
  NAME_REGEXP
}
